import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=ddc46792&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=ddc46792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc46792",
  null
  
)

export default component.exports